// extracted by css-extract-rspack-plugin
export default {"cls1":"premium_reader_products_modal-cls1_jKo","cls2":"premium_reader_products_modal-cls2_hN2 premium_reader_products_modal-cls1_jKo"};